module.exports = __webpack_public_path__ + "static/media/jiayan.7737e328.png";